<template>
  <MainLayout>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <template v-for="tab in tabs">
        <v-tab :key="tab.name" :to="{ name: tab.name }" ripple>{{ $t(tab.label) }}</v-tab>
      </template>
    </v-tabs>
    <router-view></router-view>
  </MainLayout>
</template>

<script>
export default {
  data() {
    return {
      currentView: 'agent-overview'
    }
  },
  computed: {
    tabs() {
      return [
        {
          name: 'ticket3-agent-overview',
          label: 'agent overview'
        },
        ...(this.$store.state.privilege &&
        ['all', 'supervisor', 'superadmin'].includes(this.$store.state.privilege.role)
          ? [
              {
                name: 'ticket3-agent-performance-detail',
                label: 'agent performance'
              }
            ]
          : []),
        ...(this.$store.state.privilege &&
        ['all', 'superadmin'].includes(this.$store.state.privilege.role)
          ? [
              {
                name: 'ticket3-admin-management',
                label: 'agent management'
              }
            ]
          : [])
      ].filter(Boolean)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/LayoutAgentManagement.vue